// Bottom action bar (DESIGN.md 7, 10.1): sticky, mobile-only (md:hidden).
// Single primary action slot, safe-area inset padding.

interface Props {
  children: React.ReactNode;
}

export function BottomActionBar({ children }: Props) {
  return <div className="bottom-bar" role="group" aria-label="操作栏">{children}</div>;
}
